import './styles/index.scss';
import './styles/App.scss';
import AppRoutes from './routes';


const App: React.FC = () => {

  return (
    <div className='pepper-background'>
      <AppRoutes />
    </div>
  );
}

export default App;
